<div class="container">
  <div id="administration" class="content">
    <div class="notes-detail-title">
      <span>Administration</span>
    </div>
    <div class="card-deck">
      <div *ngIf="canAddNotes === undefined && canAddApps === undefined" class="col-md-12" style="padding: 50px 0px 75px; text-align:center">
        <h3>Waiting...</h3>
    </div>
      <div *ngIf="canAddNotes === false && canAddApps === false" class="col-md-12" style="padding: 50px 0px 75px; text-align:center">
          <h3>You do not currently have any admin privileges granted.</h3>
      </div>
      <div *ngIf="canAddNotes" class="col-md-12 detail">
        <button id="noteEntry" class="btn btn-link" type="button" routerLink="/noteEntry">
          <span>Note Entry</span>
        </button>
      </div>
      <div *ngIf="canAddApps" class="col-md-12 detail">
        <button id="AppEntry" class="btn btn-link" type="button" routerLink="/applicationEntry">
          <span>Application Entry</span>
        </button>
      </div>
    </div>
  </div>
</div>
